import * as React from 'react';
import Typography from '@material-ui/core/Typography';
import { withIntl, IntlProps } from 'ha/i18n';

import { TypeFilterValue, TypeValue } from 'ha/types/SearchFilters';
import FilterCheckbox from './FilterCheckbox';

interface Props {
  types: TypeFilterValue;
  className?: string;
  onToggle: (type: string, selected: boolean) => void;
}

export const TypeFilter: React.SFC<Props & IntlProps> = ({
  types,
  onToggle,
  intl: { T },
}) => (
  <React.Fragment>
    <Typography variant="subheading">{T('Type')}</Typography>

    <FilterCheckbox
      name={`${TypeValue.APARTMENT}-checkbox`}
      isActive={types.includes(TypeValue.APARTMENT)}
      onToggle={(selected: boolean) => onToggle(TypeValue.APARTMENT, selected)}
      data-test-locator="Filter Apartment"
    >
      {T('Apartment')}
    </FilterCheckbox>
    <FilterCheckbox
      name={`${TypeValue.PRIVATE_ROOM}-checkbox`}
      isActive={types.includes(TypeValue.PRIVATE_ROOM)}
      onToggle={(selected: boolean) =>
        onToggle(TypeValue.PRIVATE_ROOM, selected)
      }
      data-test-locator="Filter Private Room"
    >
      {T('Private Room')}
    </FilterCheckbox>
    <FilterCheckbox
      name={`${TypeValue.SHARED_ROOM}-checkbox`}
      isActive={types.includes(TypeValue.SHARED_ROOM)}
      onToggle={(selected: boolean) =>
        onToggle(TypeValue.SHARED_ROOM, selected)
      }
      data-test-locator="Filter Shared Room"
    >
      {T('Shared Room')}
    </FilterCheckbox>
    <FilterCheckbox
      name={`${TypeValue.STUDIO}-checkbox`}
      isActive={types.includes(TypeValue.STUDIO)}
      onToggle={(selected: boolean) => onToggle(TypeValue.STUDIO, selected)}
      data-test-locator="Filter Studio"
    >
      {T('Studio')}
    </FilterCheckbox>
  </React.Fragment>
);

export default withIntl(TypeFilter);
